import { useContext, useState } from "react";
import { parseDateIso, Validate } from "../../../../utils/EventoUtils";
import Alerts from "../../../components/Alerts/Alerts";
import Input from "../../../components/custom/forms/Input";
import EntradaModal from "../modals/EntradaModal";
import { contextProvider } from "../../../../context/ContextProvider";
import RestApi from "../../../../helpers/RestApi";
import CheckBox from "../../../components/custom/forms/CheckBox";
import RestPrivateAntesala from "../../../../helpers/RestPrivateApi";
import { format } from "date-fns";

const Entradas = ({
  setForm,
  form,
  setValidation,
  validation,
  setModal,
  modal,
  tieneSiteMap,
  soloLectura,
}) => {
  const context = useContext(contextProvider);
  const { FORMs, VALIDATIONs, URLs } = context;

  const { VALIDATION_FORM_EVENTO } = VALIDATIONs;
  const { URL_ENTRADA_UPDATE } = URLs;

  const [loading, setLoading] = useState(false);
  const [cuadranteConfigNuevo, setCuadranteConfigNuevo] = useState({ filas: [] });

  // Agregar una nueva fila al cuadrante
  const agregarFilaNueva = () => {
    const ultimaFila = cuadranteConfigNuevo.filas[cuadranteConfigNuevo.filas.length - 1];
    const nuevoNumero = cuadranteConfigNuevo.filas.length + 1;
    const nuevoInicio = ultimaFila ? ultimaFila.fin + 1 : 1;

    setCuadranteConfigNuevo({
      ...cuadranteConfigNuevo,
      filas: [
        ...cuadranteConfigNuevo.filas,
        {
          numero: nuevoNumero,
          inicio: nuevoInicio,
          fin: nuevoInicio + 19 // 20 asientos por defecto
        }
      ]
    });
  };

  // Eliminar una fila del cuadrante
  const eliminarFilaNueva = (index) => {
    const nuevasFilas = cuadranteConfigNuevo.filas.filter((_, i) => i !== index);
    setCuadranteConfigNuevo({ filas: nuevasFilas });
  };

  // Actualizar una fila específica
  const actualizarFilaNueva = (index, campo, valor) => {
    const nuevasFilas = [...cuadranteConfigNuevo.filas];
    nuevasFilas[index][campo] = parseInt(valor) || 0;
    setCuadranteConfigNuevo({ filas: nuevasFilas });
  };

  const onClick = async (e, value) => {
    switch (e.target.name) {
      case "entrada-editar":
        {
          let input = form;

          input["entrada-id"][0] = input.entradas[0][value].id[0];
          input["entrada-tipo"][0] = input.entradas[0][value].nombre[0];
          input["entrada-gratis"][0] = input.entradas[0][value].gratis[0];
          input["entrada-precio"][0] = input.entradas[0][value].precio[0];
          input["entrada-habilitacion"][0] =
            input.entradas[0][value].habilitacion_fecha[0];
          input["entrada-vencimiento"][0] =
            input.entradas[0][value].vencimiento_fecha[0];
          input["entrada-cierre"][0] =
            input.entradas[0][value].habilitacion_hora[0];
          input["entrada-multiplicador"][0] =
            input.entradas[0][value].multiplicador[0];
          input["entrada-stock"][0] = input.entradas[0][value].stock[0];
          input["entrada-sector"][0] = input.entradas[0][value].sector[0];
          input["entrada-status"][0] = input.entradas[0][value].status_id[0];
          input["entrada-cuadrante-config"] = input.entradas[0][value].cuadrante_config || ["", ""];
          input["entrada-is-bonus"] = input.entradas[0][value].is_bonus ? input.entradas[0][value].is_bonus : [0, ""];

          setForm({
            ...input,
            ["entrada-id"]: input["entrada-id"],
            ["entrada-tipo"]: input["entrada-tipo"],
            ["entrada-gratis"]: input["entrada-gratis"],
            ["entrada-precio"]: input["entrada-precio"],
            ["entrada-habilitacion"]: input["entrada-habilitacion"],
            ["entrada-vencimiento"]: input["entrada-vencimiento"],
            ["entrada-cierre"]: input["entrada-cierre"],
            ["entrada-multiplicador"]: input["entrada-multiplicador"],
            ["entrada-stock"]: input["entrada-stock"],
            ["entrada-sector"]: input["entrada-sector"],
            ["entrada-status"]: input["entrada-status"],
            ["entrada-cuadrante-config"]: input["entrada-cuadrante-config"],
            ["entrada-is-bonus"]: input["entrada-is-bonus"],
          });

          setModal({
            ...modal,
            entrada: {
              status: true,
              data: value,
            },
          });
        }
        break;
      case "entrada-status":
        {
          let input = form;
          let result = input.entradas[0];

          result[value].status_id[0] = result[value].status_id[0] == 1 ? 2 : 1;

          setForm({
            ...form,
            entradas: [result, "required"],
          });

          if (form.id[0]) {
            /* UPDATE */
            let formData = new FormData();
            formData.append("_method", "PUT");
            formData.append("id", result[value].id[0]);
            formData.append("status_id", result[value].status_id[0]);

            const response = await RestPrivateAntesala({
              url: '/entradas',
              formData: formData,
              method: "post",
              setLoading: setLoading,
            });

            //Error
            if (response.status == 201 || response.status == 200) {
              return Alerts({
                msg: "Alert",
                title: response.data.msg,
                code: "401",
                type: "success",
              });
            } else {
              if (typeof response.data.msg === "string") {
                Alerts({
                  msg: "Alert",
                  title: response.data.msg,
                  code: "200",
                  type: "success",
                });
              }

              Object.keys(response.data.msg).map((key) => {
                return Alerts({
                  msg: "Alert",
                  title: response.data.msg[key][0],
                  code: "401",
                  type: "error",
                });
              });
            }
          }
        }
        break;
      case "entrada-delete":
        {
          // Validar si el evento tiene mapa de teatro
          if (tieneSiteMap) {
            return Alerts({
              msg: "Error",
              title: "No se pueden eliminar entradas de un evento con mapa de teatro asignado",
              code: "403",
              type: "error",
            });
          }

          if (!window.confirm("¿Estás seguro de eliminar esta entrada?")) {
            return;
          }

          let input = form;
          let result = input.entradas[0];

          delete result[value];
          result = result.filter((i) => i != null);

          setForm({
            ...form,
            entradas: [result, "required"],
          });

          Alerts({
            msg: "Success",
            title: "Entrada eliminada correctamente",
            code: "200",
            type: "success",
          });
        }
        break;
      case "entrada-añadir":
        {
          const input_validation = Validate(
            form,
            JSON.parse(JSON.stringify(VALIDATION_FORM_EVENTO)),
            "entrada"
          );
          setValidation(input_validation);
          //Validaciones
          if (input_validation.error.status) {
            return Alerts({
              msg: "Warning",
              title: input_validation.error.msg,
              code: "404",
              type: "error",
            });
          }

          if(
            !form["entrada-habilitacion"][0] ||
             form["entrada-habilitacion"][0] == ''
          ){
            return Alerts({
              msg: "Warning",
              title: "Añade una fecha de inicio para agregar tu entrada",
              code: "404",
              type: "error",
            });
          }

          let result = form.entradas[0];

          // Preparar cuadrante_config si existe
          let cuadranteConfigValue = null;
          if (form["entrada-sector"][0] && cuadranteConfigNuevo.filas.length > 0) {
            cuadranteConfigValue = JSON.stringify(cuadranteConfigNuevo);
          }

          let input = {
            id: [null, "required"],
            evento_id: [null, "required"],
            nombre: [form["entrada-tipo"][0], "required"],
            tipo: ["", ""],
            gratis: [form["entrada-gratis"][0], ""],
            precio: [form["entrada-precio"][0], "required"],
            habilitacion_hora: [form["entrada-cierre"][0], "required"],
            habilitacion_fecha: [form["entrada-habilitacion"][0], "required"],
            vencimiento_fecha: [form["entrada-vencimiento"][0], ""],
            stock: [form["entrada-stock"][0], ""],
            sector: [form["entrada-sector"][0], ""],
            multiplicador: [form["entrada-multiplicador"][0], ""], // Opcional
            status_id: [form["entrada-status"][0], "required"],
            cuadrante_config: [cuadranteConfigValue, ""],
            is_bonus: [form["entrada-is-bonus"] ? form["entrada-is-bonus"][0] : 0, ""],
            created_at: [new Date(), "required"],
            update_at: [new Date(), "required"],
          };

          result.push(input)

          const ultimaFecha = parseDateIso(form.fechas[0][form.fechas[0].length - 1].fechas[0]);

          if (form.id[0]) {
            /* UPDATE */
            let formData = new FormData();
            formData.append("evento_id", form.id[0]);
            formData.append("status_id", form["entrada-status"][0]);
            formData.append("nombre", form["entrada-tipo"][0]);
            formData.append(
              "tipo",
              form["entrada-precio"][0] > 0
                ? "VENTA"
                : form["entrada-gratis"][0].toUpperCase()
            );
            formData.append("precio", form["entrada-precio"][0]);
            formData.append("stock", form["entrada-stock"][0]);
            formData.append(
              "habilitacion_fecha",
              form["entrada-habilitacion"][0]
            );

            formData.append("habilitacion_hora", form["entrada-cierre"][0]);
            if (form["entrada-vencimiento"][0]) {
              formData.append(
                "vencimiento_fecha",
                form["entrada-vencimiento"][0]
              );
            }
            if (form["entrada-multiplicador"][0]) {
              formData.append(
                "multiplicador",
                form["entrada-multiplicador"][0]
              );
            }
            if (form["entrada-sector"][0]) {
              formData.append(
                "sector",
                form["entrada-sector"][0]
              );
            }
            if (cuadranteConfigValue) {
              formData.append(
                "cuadrante_config",
                cuadranteConfigValue
              );
            }
            formData.append(
              "is_bonus",
              form["entrada-is-bonus"] && form["entrada-is-bonus"][0] == 1 ? 1 : 0
            );

            const response = await RestPrivateAntesala({
              url: '/entradas',
              formData: formData,
              method: "post",
              setLoading: setLoading,
            });

            //Error
            if (response.status == 201 || response.status == 200) {
              result[result.length - 1].id[0] = response.data.data.id;

              // Resetear cuadrante config
              setCuadranteConfigNuevo({ filas: [] });

              setForm({
                ...form,
                entradas: [result, ""],
                ["entrada-id"]: [null, ""],
                ["entrada-status"]: [1, ""],
                ["entrada-tipo"]: ["", ""],
                ["entrada-gratis"]: [null, ""],
                ["entrada-precio"]: [0, ""],
                ["entrada-cierre"]: ["00:00", ""],
                ["entrada-multiplicador"]: [null, ""],
                ["entrada-habilitacion"]: [format(new Date(), 'yyyy-MM-dd').toString(), ""],
                ["entrada-vencimiento"]: [ultimaFecha ?? "", ""],
                ["entrada-stock"]: [null, ""],
                ["entrada-sector"]: ["", ""],
              });

              return Alerts({
                msg: "Alert",
                title: response.data.msg,
                code: "401",
                type: "success",
              });
            } else {
              if (typeof response.data.msg === "string") {
                Alerts({
                  msg: "Alert",
                  title: response.data.msg,
                  code: "200",
                  type: "success",
                });
              }

              Object.keys(response.data.msg).map((key) => {
                return Alerts({
                  msg: "Alert",
                  title: response.data.msg[key][0],
                  code: "401",
                  type: "error",
                });
              });
            }
          } else {
            // Resetear cuadrante config
            setCuadranteConfigNuevo({ filas: [] });

            setForm({
              ...form,
              entradas: [result, ""],
              ["entrada-id"]: [null, ""],
              ["entrada-status"]: [1, ""],
              ["entrada-tipo"]: ["", ""],
              ["entrada-gratis"]: [null, ""],
              ["entrada-precio"]: [0, ""],
              ["entrada-cierre"]: ["00:00", ""],
              ["entrada-multiplicador"]: [null, ""],
              ["entrada-habilitacion"]: [format(new Date(), 'yyyy-MM-dd').toString(), ""],
              ["entrada-vencimiento"]: [ultimaFecha ?? "", ""],
              ["entrada-stock"]: [null, ""],
              ["entrada-sector"]: ["", ""],
            });

            Alerts({
              msg: "Warning",
              title: "Creando entrada",
              code: "404",
              type: "success",
            });
          }
        }
        break;
    }
  };

  const onChange = (e, value) => {
    switch (e.target.name) {
      case "entrada-is-bonus":
        {
          let input = form;
          // Inicializar si no existe
          if (!input[e.target.name]) {
            input[e.target.name] = [0, ""];
          }
          // Toggle entre 1 y 0
          input[e.target.name][0] = input[e.target.name][0] == 1 ? 0 : 1;

          setForm({
            ...form,
            [e.target.name]: input[e.target.name],
          });
        }
        break;
      case "entrada-gratis":
        {
          let input = form;
          input[e.target.name][0] = value;
          input["entrada-precio"][0] = 0;

          setForm({
            ...form,
            [e.target.name]: input[e.target.name],
          });
        }
        break;
      case "entrada-precio":
        {
          let input = form;
          if (e.target.value > 0) {
            input["entrada-gratis"][0] = null;
          }
          input[e.target.name][0] = e.target.value;

          setForm({
            ...form,
            [e.target.name]: input[e.target.name],
          });
        }
        break;
      case "entrada-tipo":
      case "entrada-vencimiento":
      case "entrada-habilitacion":
      case "entrada-cierre":
      case "entrada-stock":
      case "entrada-sector":
        {
          let input = form;
          input[e.target.name][0] = e.target.value;

          // Limpiar validación si el campo tiene contenido
          if (e.target.value && e.target.value.trim() !== "") {
            setValidation({
              ...validation,
              [e.target.name]: {
                status: false,
                msg: "",
              },
            });
          }

          setForm({
            ...form,
            [e.target.name]: input[e.target.name],
          });
        }
        break;
      case "entrada-multiplicador":
        {
          let input = form;
          // Convertir a número o null si está vacío
          const valor = e.target.value === "" ? null : e.target.value;
          input[e.target.name][0] = valor;

          setForm({
            ...form,
            [e.target.name]: input[e.target.name],
          });
        }
        break;
    }
  };

  return (
    <div className="container-md w-100 tw-space-y-6">
      <div className="border p-3 mb-4 tw-bg-white tw-shadow-lg tw-border-gray-200 tw-transition-all hover:tw-shadow-xl" style={{ borderRadius: "1rem" }}>
        <div className="row">
          <div className="col-md-12 mb-3 px-1">
            <h5 className="GothamBold d-flex align-items-center tw-text-2xl tw-font-bold tw-text-gray-800 tw-mb-4">
              <i className="bi bi-ticket-perforated me-2 text-dark tw-mr-3 tw-text-purple-600 tw-text-3xl"></i>
              Entradas
              <span className="badge bg-danger ms-2 tw-ml-3 tw-px-3 tw-py-1 tw-text-xs tw-bg-red-500 tw-text-white tw-rounded-full tw-animate-pulse" style={{ fontSize: "0.7rem" }}>Obligatorio</span>
            </h5>
            <p className="text-muted small mb-3 tw-flex tw-items-center tw-text-gray-600 tw-bg-purple-50 tw-p-3 tw-rounded-lg">
              <i className="bi bi-info-circle me-1 tw-text-purple-500 tw-text-lg tw-mr-2"></i>
              Configura los tipos de entradas, precios, fechas de venta y capacidad disponible
            </p>

            {tieneSiteMap && (
              <div className="alert alert-warning mb-3">
                <i className="bi bi-lock-fill me-2"></i>
                <strong>Evento con mapa de teatro asignado</strong>
                <p className="mb-0 mt-2 small">
                  Las entradas de este evento están vinculadas a un mapa de asientos y no pueden eliminarse.
                  Puedes editar sus propiedades (precio, fechas, stock) pero no eliminarlas.
                </p>
              </div>
            )}

            <hr className="tw-border-t-2 tw-border-gray-200 tw-my-4" />
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <h6 className="d-flex align-items-center mb-3 tw-text-lg tw-font-bold tw-text-gray-700 tw-mb-4">
              <i className="bi bi-plus-square me-2 text-dark tw-text-purple-500 tw-text-2xl tw-mr-3"></i>
              Crear nueva entrada
            </h6>
            <div className="mb-3">
              <Input
                onChange={onChange}
                label={"Nombre de la entrada"}
                name={"entrada-tipo"}
                type={"text"}
                value={form["entrada-tipo"][0]}
                svg={'<i class="bi bi-tag"></i>'}
                validate={validation["entrada-tipo"]}
                disabled={false}
              />
              <small className="text-muted tw-flex tw-items-center tw-text-gray-600 tw-bg-purple-50 tw-p-2 tw-rounded-lg tw-mt-2">
                <i className="bi bi-lightbulb me-1 tw-text-purple-500 tw-mr-1"></i>
                Ejemplos: General, VIP, Early Bird, Estudiante, etc.
              </small>
            </div>

            <div className="mb-3">
              <label className="form-label text-muted d-flex align-items-center" style={{ fontSize: "14px" }}>
                <i className="bi bi-currency-dollar me-2 text-dark"></i>
                Precio y tipo de entrada <span className="text-danger ms-1">*</span>
              </label>

              <div className="row g-2">
                <div className="col-12">
                  <Input
                    onChange={onChange}
                    label={null}
                    name={"entrada-precio"}
                    type={"number"}
                    value={form["entrada-precio"][0]}
                    svg={'<i class="bi bi-cash-coin"></i>'}
                    validate={validation["entrada-precio"]}
                    disabled={form["entrada-gratis"][0] ? true : false}
                  />
                </div>
                <div className="col-12">
                  <div className="border rounded p-3 bg-light">
                    <small className="text-muted d-block mb-2">
                      <i className="bi bi-gift me-1"></i>
                      O selecciona una opción gratuita:
                    </small>
                    <div className="d-flex gap-3">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="entrada-gratis-radio"
                          id="gratis-radio"
                          checked={form["entrada-gratis"][0] == "GRATIS"}
                          onChange={(e) => onChange({ target: { name: "entrada-gratis", value: "GRATIS" } }, "GRATIS")}
                        />
                        <label className="form-check-label" htmlFor="gratis-radio">
                          Gratis
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="entrada-gratis-radio"
                          id="gorra-radio"
                          checked={form["entrada-gratis"][0] == "A LA GORRA"}
                          onChange={(e) => onChange({ target: { name: "entrada-gratis", value: "A LA GORRA" } }, "A LA GORRA")}
                        />
                        <label className="form-check-label" htmlFor="gorra-radio">
                          A la gorra
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="entrada-gratis-radio"
                          id="pago-radio"
                          checked={!form["entrada-gratis"][0]}
                          onChange={(e) => onChange({ target: { name: "entrada-gratis", value: null } }, null)}
                        />
                        <label className="form-check-label" htmlFor="pago-radio">
                          De pago
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mb-3">
              <div className="border rounded p-3 bg-light">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="entrada-is-bonus-check"
                    name="entrada-is-bonus"
                    checked={form["entrada-is-bonus"] && form["entrada-is-bonus"][0] == 1}
                    onChange={(e) => onChange(e)}
                  />
                  <label className="form-check-label d-flex align-items-center" htmlFor="entrada-is-bonus-check">
                    <i className="bi bi-gift-fill me-2 text-primary"></i>
                    <strong>¿Es un bono de contribución?</strong>
                  </label>
                </div>
                <small className="text-muted d-block mt-2">
                  <i className="bi bi-info-circle me-1"></i>
                  Marca esta opción si esta entrada es un bono de contribución o donación
                </small>
              </div>
            </div>

            <div className="mb-2 d-none">
              <Input
                onChange={onChange}
                label={"Descuento"}
                name={"entrada-descuento"}
                type={"number"}
                value={form["entrada-precio"][0]}
                svg={
                  ' <svg width="10" height="10" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_3124_63597)"><path d="M8.08541 14.5625C9.96177 14.5625 11.7613 13.8711 13.0881 12.6404C14.4148 11.4097 15.1602 9.74048 15.1602 8C15.1602 6.25952 14.4148 4.59032 13.0881 3.35961C11.7613 2.1289 9.96177 1.4375 8.08541 1.4375C6.20906 1.4375 4.40956 2.1289 3.08277 3.35961C1.75599 4.59032 1.01061 6.25952 1.01061 8C1.01061 9.74048 1.75599 11.4097 3.08277 12.6404C4.40956 13.8711 6.20906 14.5625 8.08541 14.5625ZM8.08541 15.5C5.94101 15.5 3.88443 14.7098 2.36811 13.3033C0.851788 11.8968 -7.24792e-05 9.98912 -7.24792e-05 8C-7.24792e-05 6.01088 0.851788 4.10322 2.36811 2.6967C3.88443 1.29018 5.94101 0.5 8.08541 0.5C10.2298 0.5 12.2864 1.29018 13.8027 2.6967C15.319 4.10322 16.1709 6.01088 16.1709 8C16.1709 9.98912 15.319 11.8968 13.8027 13.3033C12.2864 14.7098 10.2298 15.5 8.08541 15.5V15.5Z" fill="white" /><path d="M7.14564 6.67625L9.46012 6.94531L9.54299 7.30156L9.08818 7.37938C8.79104 7.445 8.73242 7.54438 8.79711 7.81906L9.54299 11.0703C9.73906 11.9113 9.43687 12.3069 8.72636 12.3069C8.17553 12.3069 7.53577 12.0706 7.2457 11.7463L7.15676 11.3563C7.3589 11.5213 7.65402 11.5869 7.85009 11.5869C8.12803 11.5869 8.2291 11.4059 8.15734 11.0872L7.14564 6.67625ZM7.0749 4.71875C7.0749 4.96739 7.18138 5.20585 7.37092 5.38166C7.56046 5.55748 7.81753 5.65625 8.08558 5.65625C8.35363 5.65625 8.6107 5.55748 8.80025 5.38166C8.98979 5.20585 9.09627 4.96739 9.09627 4.71875C9.09627 4.47011 8.98979 4.23165 8.80025 4.05584C8.6107 3.88002 8.35363 3.78125 8.08558 3.78125C7.81753 3.78125 7.56046 3.88002 7.37092 4.05584C7.18138 4.23165 7.0749 4.47011 7.0749 4.71875Z" fill="white" /> </g><defs><clipPath id="clip0_3124_63597"> <rect width="16.171" height="15" fill="white" transform="matrix(-1 0 0 1 16.1709 0.5)" /> </clipPath> </defs></svg>'
                }
                validate={validation["entrada-precio"]}
                disabled={false}
              />
            </div>

            <div className="row g-2 mb-3">
              <div className="col-md-6">
                <Input
                  onChange={onChange}
                  label={"Fecha de inicio de venta"}
                  name={"entrada-habilitacion"}
                  type={"date"}
                  value={form["entrada-habilitacion"][0]}
                  svg={'<i class="bi bi-calendar-check"></i>'}
                  validate={validation["entrada-habilitacion"]}
                  disabled={false}
                />
              </div>
              <div className="col-md-6">
                <Input
                  onChange={onChange}
                  label={"Fecha de fin de venta (opcional)"}
                  name={"entrada-vencimiento"}
                  type={"date"}
                  value={form["entrada-vencimiento"][0]}
                  svg={'<i class="bi bi-calendar-x"></i>'}
                  validate={validation["entrada-vencimiento"]}
                  disabled={false}
                />
              </div>
            </div>

            <div className="mb-3">
              <div className="border rounded p-3 bg-light">
                <div className="form-check form-switch mb-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="flexSwitchCheckChecked"
                    onChange={function (event) {
                      if (event.target.checked) {
                        document.getElementById("stock-unico").classList.remove("d-none");
                        document.getElementById("sector-unico").classList.remove("d-none");
                      } else {
                        document.getElementById("stock-unico").classList.add("d-none");
                        document.getElementById("sector-unico").classList.add("d-none");
                      }
                    }}
                  />
                  <label className="form-check-label d-flex align-items-center" htmlFor="flexSwitchCheckChecked">
                    <i className="bi bi-box-seam me-2 text-dark"></i>
                    <strong>Habilitar capacidad individual</strong>
                    <i
                      className="bi bi-info-circle text-info ms-2"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Asigna un stock específico para este tipo de entrada. Por defecto, usa la capacidad general de cada función."
                      style={{ cursor: "pointer" }}
                    ></i>
                  </label>
                </div>
                <div id="stock-unico" className="d-none">
                  <Input
                    onChange={onChange}
                    label={"Capacidad para esta entrada"}
                    name={"entrada-stock"}
                    type={"number"}
                    value={form["entrada-stock"][0]}
                    svg={'<i class="bi bi-box-seam"></i>'}
                    validate={validation["entrada-stock"]}
                    disabled={false}
                  />
                  <small className="text-muted">
                    <i className="bi bi-exclamation-triangle me-1"></i>
                    Se aplica a todas las fechas del evento
                  </small>
                </div>
                <div id="sector-unico" className="d-none mt-3">
                  <Input
                    disabled={false}
                    onChange={onChange}
                    label={"Sector"}
                    name={"entrada-sector"}
                    type={"text"}
                    value={form["entrada-sector"][0]}
                    svg={'<i class="bi bi-map"></i>'}
                    validate={validation["entrada-sector"]}
                  />
                  <small className="text-muted">
                    <i class="bi bi-info-circle me-1"></i>
                    Nombre del sector (ej: Platea, Pullman, Palco)
                  </small>

                  {/* Configuración de Cuadrante para nueva entrada */}
                  {form["entrada-sector"][0] && form["entrada-stock"][0] > 0 && (
                    <div className="mt-3 border rounded p-3 bg-white">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <div>
                          <h6 className="mb-1">
                            <i className="bi bi-grid-3x3-gap me-2"></i>
                            Configuración de Cuadrante
                          </h6>
                          <small className="text-muted">
                            Define la distribución de asientos por fila
                          </small>
                        </div>
                        <button
                          type="button"
                          className="btn btn-sm btn-primary"
                          onClick={agregarFilaNueva}
                        >
                          <i className="bi bi-plus-circle me-1"></i>
                          Agregar Fila
                        </button>
                      </div>

                      {cuadranteConfigNuevo.filas.length === 0 ? (
                        <div className="text-center text-muted py-3">
                          <i className="bi bi-grid-3x3-gap" style={{ fontSize: "2rem", opacity: 0.3 }}></i>
                          <p className="mb-0 mt-2">No hay filas configuradas</p>
                          <small>Haz clic en "Agregar Fila" para comenzar</small>
                        </div>
                      ) : (
                        <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                          {cuadranteConfigNuevo.filas.map((fila, index) => (
                            <div key={index} className="border rounded p-2 mb-2 bg-light">
                              <div className="row g-2 align-items-center">
                                <div className="col">
                                  <label className="form-label mb-1" style={{ fontSize: "11px" }}>
                                    Nº Fila
                                  </label>
                                  <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    value={fila.numero}
                                    onChange={(e) => actualizarFilaNueva(index, 'numero', e.target.value)}
                                    min="1"
                                    placeholder="Ej: 1"
                                  />
                                </div>
                                <div className="col">
                                  <label className="form-label mb-1" style={{ fontSize: "11px" }}>
                                    Inicio
                                  </label>
                                  <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    value={fila.inicio}
                                    onChange={(e) => actualizarFilaNueva(index, 'inicio', e.target.value)}
                                    min="1"
                                    placeholder="Ej: 1"
                                  />
                                </div>
                                <div className="col">
                                  <label className="form-label mb-1" style={{ fontSize: "11px" }}>
                                    Fin
                                  </label>
                                  <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    value={fila.fin}
                                    onChange={(e) => actualizarFilaNueva(index, 'fin', e.target.value)}
                                    min={fila.inicio}
                                    placeholder="Ej: 24"
                                  />
                                </div>
                                <div className="col-auto">
                                  <label className="form-label mb-1" style={{ fontSize: "11px" }}>
                                    &nbsp;
                                  </label>
                                  <div>
                                    <span className="badge bg-info">
                                      {fila.fin - fila.inicio + 1} asientos
                                    </span>
                                  </div>
                                </div>
                                <div className="col-auto">
                                  <label className="form-label mb-1" style={{ fontSize: "11px" }}>
                                    &nbsp;
                                  </label>
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-outline-danger"
                                    onClick={() => eliminarFilaNueva(index)}
                                    title="Eliminar fila"
                                  >
                                    <i className="bi bi-trash"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}

                      {cuadranteConfigNuevo.filas.length > 0 && (
                        <div className="mt-2 p-2 bg-light border rounded">
                          <small className="text-muted">
                            <i className="bi bi-info-circle me-1"></i>
                            <strong>Total configurado:</strong> {
                              cuadranteConfigNuevo.filas.reduce((sum, fila) => sum + (fila.fin - fila.inicio + 1), 0)
                            } asientos en {cuadranteConfigNuevo.filas.length} fila(s)
                          </small>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="row g-2 mb-3">
              <div className="col-md-6">
                <label className="form-label text-muted d-flex align-items-center" style={{ fontSize: "14px" }}>
                  <i className="bi bi-clock me-2 text-dark"></i>
                  Hora de cierre de venta
                </label>
                <select
                  className="form-select"
                  name="entrada-cierre"
                  onChange={(event) => onChange(event)}
                >
                  <option value="01:00">Una hora antes de la función</option>
                  <option value="00:00">Misma hora de función</option>
                  <option value="23:00">Al finalizar el día</option>
                </select>
              </div>

              <div className="col-md-6">
                <label className="form-label text-muted d-flex align-items-center" style={{ fontSize: "14px" }}>
                  <i className="bi bi-x-diamond me-2 text-dark"></i>
                  Multiplicador (Opcional)
                  <i
                    className="bi bi-info-circle text-info ms-2"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Para promociones 2x1, 3x1, etc. Cada entrada cuenta como múltiples asientos."
                    style={{ cursor: "pointer" }}
                  ></i>
                </label>
                <select
                  className="form-select"
                  name="entrada-multiplicador"
                  onChange={(event) => onChange(event)}
                  value={form["entrada-multiplicador"][0] || ""}
                >
                  <option value="">Sin multiplicador</option>
                  <option value="2">2x1 (Dos por uno)</option>
                  <option value="3">3x1 (Tres por uno)</option>
                  <option value="4">4x1 (Cuatro por uno)</option>
                </select>
              </div>
            </div>

            {/* Botón Añadir Entrada - Oculto en modo solo lectura */}
            {!soloLectura && (
              <div className="mb-2">
                <label className="btn btn-primary fw-normal GothamBold text-white w-100 py-2 tw-py-3" style={{ cursor: "pointer" }}>
                  <i className="bi bi-plus-circle me-2 tw-text-lg"></i>
                  Añadir Entrada
                  <button
                    className="d-none"
                    name="entrada-añadir"
                    onClick={(event) => onClick(event)}
                  ></button>
                </label>

                {validation.entradas.status ? (
                  <div className="text-danger mt-2 tw-bg-red-50 tw-border-l-4 tw-border-red-500 tw-p-3 tw-rounded-r-lg tw-mt-3">
                    <i className="bi bi-exclamation-triangle me-1 tw-text-red-600"></i>
                    <span className="tw-text-red-700 tw-font-medium">{validation.entradas.msg}</span>
                  </div>
                ) : (
                  ""
                )}
              </div>
            )}
          </div>

          <div className="col-md-6">
            <div className="d-flex justify-content-between align-items-center mb-3 tw-mb-4">
              <h6 className="d-flex align-items-center mb-0 tw-text-lg tw-font-bold tw-text-gray-700">
                <i className="bi bi-ticket-perforated me-2 text-dark tw-text-purple-500 tw-text-2xl tw-mr-2"></i>
                Entradas configuradas
              </h6>
              <span className={`badge tw-px-4 tw-py-2 tw-rounded-full tw-font-semibold tw-transition-all ${form.entradas[0].length > 0 ? 'bg-success tw-bg-green-500' : 'bg-secondary tw-bg-gray-400'}`}>
                <i className="bi bi-ticket-detailed me-1"></i>
                {form.entradas[0].length} entrada{form.entradas[0].length !== 1 ? 's' : ''}
              </span>
            </div>

            {validation.entradas.status && (
              <div className="alert alert-warning d-flex align-items-center mb-3 tw-bg-yellow-50 tw-border-l-4 tw-border-yellow-500 tw-p-4 tw-rounded-r-lg tw-shadow-md">
                <i className="bi bi-exclamation-triangle-fill me-2 tw-text-yellow-600 tw-text-2xl tw-mr-3"></i>
                <div>
                  <strong className="tw-text-yellow-800 tw-font-bold">¡Atención!</strong><br />
                  <span className="tw-text-yellow-700">{validation.entradas.msg === "El campo entradas es requerido."
                    ? "Debes agregar al menos una entrada para continuar"
                    : validation.entradas.msg}</span>
                </div>
              </div>
            )}

            {form.entradas[0].length === 0 ? (
              <div className="text-center text-muted py-5 border rounded bg-light tw-flex tw-flex-col tw-items-center tw-justify-center tw-bg-gray-50 tw-border-2 tw-border-dashed tw-border-gray-300 tw-rounded-2xl tw-py-12">
                <i className="bi bi-ticket-perforated tw-text-7xl tw-text-gray-300 tw-mb-4" style={{ fontSize: "3rem", opacity: 0.3 }}></i>
                <p className="mt-3 mb-0 tw-text-gray-500 tw-font-medium">No hay entradas configuradas</p>
                <small className="tw-text-gray-400">Completa el formulario y añade tus tipos de entrada</small>
              </div>
            ) : (
              <div style={{ maxHeight: "600px", overflowY: "auto" }} className="tw-space-y-3">
                <ul className="list-group tw-space-y-2">
                  {form.entradas[0].map((e, index) => {
                    const isActive = e.status_id[0] == 1;
                    const isGratis = e.gratis[0] === "GRATIS";
                    const isGorra = e.gratis[0] === "A LA GORRA";
                    const isPago = e.gratis[0]  === "DE PAGO" || e.precio[0] > 0;

                    return (
                      <li key={index} className="list-group-item mb-3 border shadow-sm p-3 pt-5 position-relative tw-bg-white tw-border-2 tw-border-gray-200 tw-rounded-xl tw-p-4 tw-pt-5 tw-transition-all hover:tw-shadow-lg hover:tw-scale-[1.01]">
                        {/* Status Badge */}
                        <div className="position-absolute top-0 end-0 m-2">
                          <span className={`badge tw-px-3 tw-py-1 tw-rounded-full tw-font-semibold ${isActive ? 'bg-success tw-bg-green-500' : 'bg-secondary tw-bg-gray-400'}`}>
                            <i className={`bi ${isActive ? 'bi-check-circle' : 'bi-dash-circle'} me-1`}></i>
                            {isActive ? 'Activa' : 'Inactiva'}
                          </span>
                        </div>

                        <div className="d-flex justify-content-between">
                          <div className="flex-grow-1 me-3">
                            {/* Nombre */}
                            <h6 className="mb-2 d-flex align-items-center tw-text-lg tw-font-bold tw-text-gray-800 tw-mb-3">
                              <i className="bi bi-ticket-detailed-fill text-dark me-2 tw-text-purple-500 tw-text-xl tw-mr-2"></i>
                              {e.nombre[0]}
                            </h6>

                            <ul className="list-unstyled mb-0">
                              {/* Precio y Tipo */}
                              <li className="mb-2 d-flex align-items-center">
                                <i className={`bi ${isGratis ? 'bi-gift-fill text-dark' : isGorra ? 'bi-hand-thumbs-up-fill text-info' : 'bi-cash-coin text-dark'} me-2`} style={{ width: "20px" }}></i>
                                <div>
                                  <span className="fw-bold">
                                    {isPago ? "$" + parseFloat(e.precio[0]).toLocaleString("es-AR", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }) : e.gratis[0]}
                                  </span>
                                  <small className="text-muted ms-2">{e.gratis[0] && e.gratis[0] !== null ? "("+e.gratis[0]+")" : ""}</small>
                                </div>
                              </li>

                              {/* Capacidad */}
                              <li className="mb-2 d-flex align-items-center">
                                <i className="bi bi-people-fill text-dark me-2" style={{ width: "20px" }}></i>
                                <span>
                                  {e.stock[0] && parseInt(e.stock[0]) > 0 ? (
                                    <>
                                      <span className="fw-bold">{e.stock[0]}</span> entradas
                                    </>
                                  ) : (
                                    <>
                                      <span className="fw-bold">General</span>
                                      <i
                                        className="ms-2 bi bi-info-circle text-info"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="La capacidad de entradas está limitada a lo asignado en cada fecha."
                                        style={{ cursor: "pointer" }}
                                      ></i>
                                    </>
                                  )}
                                </span>
                              </li>

                              {/* Sector */}
                              {e.sector && e.sector[0] && (
                                <li className="mb-2 d-flex align-items-center">
                                  <i className="bi bi-map text-dark me-2" style={{ width: "20px" }}></i>
                                  <span>
                                    <span className="fw-bold">Sector:</span> {e.sector[0]}
                                  </span>
                                </li>
                              )}

                              {/* Multiplicador */}
                              {e.multiplicador[0] && (
                                <li className="mb-2 d-flex align-items-center">
                                  <i className="bi bi-arrow-repeat text-dark me-2" style={{ width: "20px" }}></i>
                                  <span>
                                    <span className="fw-bold">Multiplicador:</span> {e.multiplicador[0]}
                                  </span>
                                </li>
                              )}

                              {/* Bono de Contribución */}
                              {e.is_bonus && e.is_bonus[0] == 1 && (
                                <li className="mb-2 d-flex align-items-center">
                                  <i className="bi bi-gift-fill text-primary me-2" style={{ width: "20px" }}></i>
                                  <span>
                                    <span className="badge bg-primary tw-bg-blue-500 tw-px-2 tw-py-1 tw-rounded-full tw-text-xs">
                                      <i className="bi bi-gift me-1"></i>
                                      Bono de contribución
                                    </span>
                                  </span>
                                </li>
                              )}

                              {/* Fechas */}
                              <li className="mb-2">
                                <div className="d-flex align-items-start">
                                  <i className="bi bi-calendar-range text-dark me-2 mt-1" style={{ width: "20px" }}></i>
                                  <div className="small">
                                    <div className="mb-1">
                                      <span className="fw-bold">Inicio:</span> {e.habilitacion_fecha[0] && e.habilitacion_fecha[0] !== "0000-00-00" ? e.habilitacion_fecha[0] : "Sin fecha"}
                                    </div>
                                    {e.vencimiento_fecha[0] && (
                                      <div>
                                        <span className="fw-bold">Fin:</span> {e.vencimiento_fecha[0] !== "0000-00-00" ? e.vencimiento_fecha[0] : "Sin fecha"}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </li>

                              {/* Hora de cierre */}
                              {e.vencimiento_fecha[0] && (
                                <li className="mb-2 d-flex align-items-center">
                                  <i className="bi bi-clock-fill text-dark me-2" style={{ width: "20px" }}></i>
                                  <span>
                                    <span className="fw-bold">Cierre:</span>{" "}
                                    {e.habilitacion_hora[0] === "00:00"
                                      ? "Misma hora de función"
                                      : e.habilitacion_hora[0] === "01:00"
                                      ? "Una hora antes de la función"
                                      : e.habilitacion_hora[0] === "23:00"
                                      ? "Al finalizar el día"
                                      : "Misma hora de función"}
                                  </span>
                                </li>
                              )}
                            </ul>

                            {/* ID de entrada */}
                            {e.id[0] && (
                              <div className="mt-2">
                                <small className="text-muted">
                                  <i className="bi bi-hash"></i>
                                  Entrada Nº{e.id[0]}
                                </small>
                              </div>
                            )}
                          </div>

                          {/* Action Buttons - Ocultos en modo solo lectura */}
                          {!soloLectura && (
                            <div className="d-flex flex-column gap-2 tw-gap-2">
                              <button
                                className="btn btn-outline-success btn-sm tw-transition-all tw-duration-200 hover:tw-scale-110 hover:tw-bg-green-500 hover:tw-text-white tw-rounded-lg"
                                onClick={(event) => {
                                  event.target.name = "entrada-editar";
                                  onClick(event, index);
                                }}
                                title="Editar entrada"
                                data-bs-toggle="tooltip"
                              >
                                <i className="bi bi-pencil"></i>
                              </button>

                              <button
                                className={`btn ${isActive ? 'btn-outline-secondary' : 'btn-secondary'} btn-sm tw-transition-all tw-duration-200 hover:tw-scale-110 tw-rounded-lg`}
                                onClick={(event) => {
                                  event.target.name = "entrada-status";
                                  onClick(event, index);
                                }}
                                title={isActive ? "Desactivar entrada" : "Activar entrada"}
                                data-bs-toggle="tooltip"
                              >
                                {isActive ? (
                                  <i className="bi bi-eye"></i>
                                ) : (
                                  <i className="bi bi-eye-slash"></i>
                                )}
                              </button>

                              {!e.id[0] && (
                                <button
                                  className={`btn btn-outline-danger btn-sm tw-transition-all tw-duration-200 tw-rounded-lg ${
                                    tieneSiteMap
                                      ? 'disabled opacity-50 cursor-not-allowed'
                                      : 'hover:tw-scale-110 hover:tw-bg-red-500 hover:tw-text-white'
                                  }`}
                                  onClick={(event) => {
                                    if (!tieneSiteMap) {
                                      event.target.name = "entrada-delete";
                                      onClick(event, index);
                                    }
                                  }}
                                  title={tieneSiteMap
                                    ? "No se pueden eliminar entradas de eventos con mapa de teatro"
                                    : "Eliminar entrada"}
                                  data-bs-toggle="tooltip"
                                  disabled={tieneSiteMap}
                                >
                                  <i className="bi bi-trash"></i>
                                  {tieneSiteMap && <i className="bi bi-lock-fill ms-1"></i>}
                                </button>
                              )}
                            </div>
                          )}
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* NUEVO: Sección de Mapa de Guía */}
      {!tieneSiteMap && form.entradas && form.entradas[0] && form.entradas[0].some(entrada => entrada.stock && entrada.stock[0] > 0) && (
        <div className="border p-3 mb-4 tw-bg-white tw-shadow-lg tw-border-gray-200 tw-transition-all hover:tw-shadow-xl" style={{ borderRadius: "1rem" }}>
          <div className="row">
            <div className="col-md-12 mb-3 px-1">
              <h5 className="GothamBold d-flex align-items-center tw-text-2xl tw-font-bold tw-text-gray-800 tw-mb-4">
                <i className="bi bi-map me-2 text-dark tw-mr-3 tw-text-blue-600 tw-text-3xl"></i>
                Mapa de Guía Visual
                <span className="badge bg-info ms-2 tw-ml-3 tw-px-3 tw-py-1 tw-text-xs tw-bg-blue-500 tw-text-white tw-rounded-full" style={{ fontSize: "0.7rem" }}>Opcional</span>
              </h5>
              <p className="text-muted small mb-3 tw-flex tw-items-center tw-text-gray-600 tw-bg-blue-50 tw-p-3 tw-rounded-lg">
                <i className="bi bi-info-circle me-1 tw-text-blue-500 tw-text-lg tw-mr-2"></i>
                Carga una imagen de referencia del mapa de asientos para ayudar a los compradores a visualizar la distribución de sectores
              </p>
              <hr className="tw-border-t-2 tw-border-gray-200 tw-my-4" />
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              {/* Zona de drag & drop */}
              <div
                className="border border-2 border-dashed rounded p-4 text-center tw-transition-all hover:tw-border-blue-500 hover:tw-bg-blue-50"
                style={{
                  borderColor: ((form["image_mapa_sitio"] && form["image_mapa_sitio"][0]) || (form["image_mapa_sitio_url"] && form["image_mapa_sitio_url"][0])) ? '#3b82f6' : '#cbd5e1',
                  backgroundColor: ((form["image_mapa_sitio"] && form["image_mapa_sitio"][0]) || (form["image_mapa_sitio_url"] && form["image_mapa_sitio_url"][0])) ? '#eff6ff' : '#f8fafc',
                  minHeight: '200px',
                  cursor: 'pointer'
                }}
                onDragOver={(e) => {
                  e.preventDefault();
                  e.currentTarget.style.borderColor = '#3b82f6';
                  e.currentTarget.style.backgroundColor = '#dbeafe';
                }}
                onDragLeave={(e) => {
                  e.preventDefault();
                  const hasImage = (form["image_mapa_sitio"] && form["image_mapa_sitio"][0]) || (form["image_mapa_sitio_url"] && form["image_mapa_sitio_url"][0]);
                  e.currentTarget.style.borderColor = hasImage ? '#3b82f6' : '#cbd5e1';
                  e.currentTarget.style.backgroundColor = hasImage ? '#eff6ff' : '#f8fafc';
                }}
                onDrop={(e) => {
                  e.preventDefault();
                  e.currentTarget.style.borderColor = '#3b82f6';
                  e.currentTarget.style.backgroundColor = '#eff6ff';

                  const files = e.dataTransfer.files;
                  if (files && files[0]) {
                    const file = files[0];
                    if (file.type.startsWith('image/')) {
                      // Guardar el archivo como blob
                      setForm({
                        ...form,
                        image_mapa_sitio: [file, '']
                      });
                    } else {
                      Alerts({
                        msg: "Error",
                        title: "Solo se permiten archivos de imagen (JPG, PNG, GIF, etc.)",
                        code: "400",
                        type: "error",
                      });
                    }
                  }
                }}
                onClick={() => {
                  // Abrir selector de archivos
                  const input = document.createElement('input');
                  input.type = 'file';
                  input.accept = 'image/*';
                  input.onchange = (e) => {
                    const file = e.target.files[0];
                    if (file) {
                      setForm({
                        ...form,
                        image_mapa_sitio: [file, '']
                      });
                    }
                  };
                  input.click();
                }}
              >
                {(form["image_mapa_sitio"] && form["image_mapa_sitio"][0]) || (form["image_mapa_sitio_url"] && form["image_mapa_sitio_url"][0]) ? (
                  <div className="tw-space-y-3">
                    <div className="tw-flex tw-justify-center tw-items-center tw-mb-3">
                      <img
                        src={
                          form["image_mapa_sitio"] && form["image_mapa_sitio"][0]
                            ? (typeof form["image_mapa_sitio"][0] === 'string'
                              ? form["image_mapa_sitio"][0]
                              : URL.createObjectURL(form["image_mapa_sitio"][0]))
                            : form["image_mapa_sitio_url"][0]
                        }
                        alt="Mapa de guía"
                        className="tw-max-h-64 tw-rounded-lg tw-shadow-md"
                        style={{ maxHeight: '300px', objectFit: 'contain' }}
                      />
                    </div>
                    <div className="tw-flex tw-items-center tw-justify-center tw-gap-2">
                      <i className="bi bi-check-circle-fill tw-text-green-500 tw-text-2xl"></i>
                      <span className="tw-font-semibold tw-text-gray-700">
                        {form["image_mapa_sitio"] && form["image_mapa_sitio"][0]
                          ? (typeof form["image_mapa_sitio"][0] === 'string'
                            ? 'Imagen cargada'
                            : form["image_mapa_sitio"][0].name)
                          : 'Imagen cargada del servidor'}
                      </span>
                    </div>
                    <button
                      type="button"
                      className="btn btn-outline-danger btn-sm mt-2"
                      onClick={(e) => {
                        e.stopPropagation();
                        setForm({
                          ...form,
                          image_mapa_sitio: ["", ''],
                          image_mapa_sitio_url: ["", '']
                        });
                      }}
                    >
                      <i className="bi bi-trash me-1"></i>
                      Eliminar imagen
                    </button>
                  </div>
                ) : (
                  <div className="tw-space-y-3 tw-py-6">
                    <div className="tw-flex tw-justify-center">
                      <i className="bi bi-cloud-arrow-up tw-text-6xl tw-text-gray-400"></i>
                    </div>
                    <div>
                      <p className="tw-text-lg tw-font-semibold tw-text-gray-700 tw-mb-2">
                        Arrastra y suelta una imagen aquí
                      </p>
                      <p className="tw-text-sm tw-text-gray-500">
                        o haz clic para seleccionar un archivo
                      </p>
                    </div>
                    <div className="tw-text-xs tw-text-gray-400 tw-mt-2">
                      Formatos soportados: JPG, PNG, GIF, WEBP
                    </div>
                  </div>
                )}
              </div>

              {((form["image_mapa_sitio"] && form["image_mapa_sitio"][0]) || (form["image_mapa_sitio_url"] && form["image_mapa_sitio_url"][0])) && (
                <div className="alert alert-info mt-3 tw-flex tw-items-start">
                  <i className="bi bi-info-circle me-2 tw-text-lg tw-mr-2"></i>
                  <div>
                    <strong>Imagen de referencia cargada</strong>
                    <p className="mb-0 small mt-1">
                      Esta imagen se mostrará a los compradores como referencia visual de la distribución de asientos.
                      {form["image_mapa_sitio"] && form["image_mapa_sitio"][0] && " Se enviará al servidor cuando guardes los cambios del evento."}
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {modal.entrada.status ? (
        <EntradaModal
          modal={modal}
          setModal={setModal}
          data={modal.entrada.data}
          validation={validation}
          form={form}
          setForm={setForm}
          url={URL_ENTRADA_UPDATE}
          loading={loading}
          setLoading={setLoading}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default Entradas;
